import React, { Component } from "react";
import * as Icon from "react-feather";
import clsx from "clsx";

import "./tools-side-panel.css";

class ToolsSidePanel extends Component {
	state = { isWide: false };

	onToggleWidth = () => this.setState(previous => ({ isWide: !previous.isWide }));

	render() {
		const { isOpen, title, back, onBack, onClose, children } = this.props;
		const { isWide } = this.state;
		if (!isOpen) return null;
		const widthLabel = isWide ? "Make the panel narrower" : "Make the panel wider";

		return (
			<div className={clsx("tk-side-panel", isWide && "tk-side-panel--wide")}>
				<div className="tk-side-panel__head">
					<div className="tk-side-panel__heading">
						{back && (
							<button type="button" className="tk-text-action tk-side-panel__back" onClick={onBack}>
								<Icon.ChevronLeft size={14} /> {back}
							</button>
						)}
						<h3 className="tk-side-panel__title">{title}</h3>
					</div>
					<div className="tk-side-panel__head-actions">
						<button type="button" className="tk-side-panel__icon-button" onClick={this.onToggleWidth} aria-label={widthLabel} title={widthLabel}>
							{isWide ? <Icon.Minimize2 size={16} /> : <Icon.Maximize2 size={16} />}
						</button>
						<button type="button" className="tk-side-panel__icon-button" onClick={onClose} aria-label="Close"><Icon.X size={18} /></button>
					</div>
				</div>
				{children}
			</div>
		);
	}
}

export default ToolsSidePanel;
